import ForgotPassword from '@features/games/profile/forgot-password/forgot-password';
export default ForgotPassword;
